import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@sd/hooks/useAuth";
import { isAgentAllowedPath } from "@sd/lib/sdAgentRouteAccess";
import { isAgentShellRole } from "@sd/lib/sdRoles";
import { SdNotFound } from "@sd/components/SdNotFound";

/** Blocks ServiceDesk_Agent from manual URL access outside allowed paths. */
export function AgentPathGuard() {
  const { role, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-7 w-7 animate-spin rounded-full border-2 border-slate-300 border-t-slate-600" />
      </div>
    );
  }

  if (isAgentShellRole(role) && !isAgentAllowedPath(location.pathname, role)) {
    return <SdNotFound />;
  }

  return <Outlet />;
}
